//import * as defaults from './Defaults'
import storage from 'redux-persist/lib/storage';
import { configuration } from './Defaults';
import { ValidationError } from 'yup';

export const routesIndex = {
    app: {
        home: '/' // + (process.env.APP_ALIAS ?? '')
        , authentication: '/autenticazione' //'/' + (process.env.APP_ALIAS ?? '') + 'authentication'
        , registration: '/registrazione'
        //, users: '/utenti' //'/' + (process.env.APP_ALIAS ?? '') + 'users'
        , anythingelse: '/*' // '/' + (process.env.APP_ALIAS ?? '') + '*'
        , me: '/profiloutente' //'/me'
        , forgotpassword : '/passworddimenticata'
        , forgotpasswordconfirmation :'/confermapassword'
        , resetpassword : '/resetpassword'

        , associations: '/associations'
        , members: '/members'
        , search: '/search'

        , memberships: {
            root: '/memberships',
            add: '/memberships/add',
            details: '/memberships/:id',
            online: '/memberships/online',
            toReview: '/memberships/to-review',
            multiple: '/memberships/multiple',
            cumulative: {
                root: '/memberships/cumulative',
                details: '/memberships/cumulative/:id',
            },
        }

        , adminpanel: '/admin/dashboard'
        , reports: '/reports'
        , singleMembershipRequests: '/single-membership-requests'
        , bulkMembershipStocks:  '/memberships/cumulative'
        , membershipRequests: '/membership-requests'
        , emailRegions: '/email-regions'
        , emailProvinces: '/email-provinces'
        , resoconti: '/resoconti'
        , emailTemplates: {
            root: '/email-templates',
            compose: '/email-templates/compose',
        }
        
        

        // APP CUSTOM
        
        , storage: {
            root: '..' + (window.location.pathname != '/' + (process.env.APP_ALIAS ?? '') ? '/..' : '') + (process.env.APP_ALIAS ?? '') + '/' + 'storage' // '../storage' // 
            , events: '../storage/events'
            , accounts: '../storage/accounts'
            , partnershiplists: '../storage/partnershiplists'
        }
    },
   
    api: {
        prefix: (process.env.APP_ALIAS ?? '') + '/api',
        
        methods: {
            index:              '/index'
            , store:            '/store'
            , update:           '/update'
            , destroy:          '/destroy'

            , search:           '/search'
            , paginate:         '/paginate'
            , view:             '/view'
            , fulltextsearch:   '/fulltextsearch'
            , filter:           '/filter'
            , create:           '/create'
            , activate:         '/activate'

            , realtime:         '/realtime'
            , import:           '/import'
            , export:           '/export'
            , validation:       '/validation'
            , notify:           '/notify'
            , archive:          '/archive'
            , check:            '/check'
            , last:             '/last'
            , fileopen:         '/fileopen'
            , filedownload:     '/filedownload'
            , fileget:          '/fileget'
            , fileupload:       '/fileupload'
            , run:              '/run'
            , restore:          '/restore' 
            , delete:           '/delete'
            , send:             '/send'
            , count:            '/count'

            , profileinformation: '/profile-information'
            
        },

        system: {
            root: '/settings',

            status: '/system-status',
            enable: '/system-enable',
            disable: '/system-disable',

            year: '/system-year',
            yearUpdate: '/system-year',
            yearEnable: '/system-year-enabled',
            yearDisable: '/system-year-disable',

            resocontiYear: '/resoconti-year',

            documentsImport: '/system-documents-import', //'/system-documents-import'
        },

        /*
        users: {
            index: (process.env.APP_ALIAS ?? '') + '/api/users' //'/api/users' //
            , store: (process.env.APP_ALIAS ?? '') + '/api/register' //'/api/register' //
            , view: (process.env.APP_ALIAS ?? '') + '/api/users/view' //'/api/users/view' //
            , update: (process.env.APP_ALIAS ?? '') + '/api/users/update'
            , destroy: (process.env.APP_ALIAS ?? '') + '/api/users/destroy'
            , create: (process.env.APP_ALIAS ?? '') + '/api/users/create'
            , activate: (process.env.APP_ALIAS ?? '') + '/api/users/activate'
            , search: (process.env.APP_ALIAS ?? '') + '/api/users/search'
            , paginate: (process.env.APP_ALIAS ?? '') + '/api/users/paginate'
        },
        */
       users: '/users',
           
        authentication: {
            csrf: '/sanctum/csrf-cookie' //'/sanctum/csrf-cookie' //
            , login: '/login'
            , user: '/user'
            , logout: '/logout'
            , forgotpassword: '/forgot-password'
            , resetpassword: '/reset-password'
            , twofactorchallenge: '/two-factor-challenge'
            , twofactorauthentication: '/user/two-factor-authentication'
            , twofactorqrcode: '/user/two-factor-qr-code'
        },

       
        dictionary: {
            root: '/api/dictionary',
        },


       
        settings : {
            root: '/settings'

            , tools: '/tools'
        },

        // accounts: '/accounts',
        
        accounts: {
            index: (process.env.APP_ALIAS ?? '') + '/api/accounts/index'
            , store: (process.env.APP_ALIAS ?? '') + '/api/accounts/store'
            , view: (process.env.APP_ALIAS ?? '') + '/api/accounts/view'
            , update: (process.env.APP_ALIAS ?? '') + '/api/accounts/update'
            , destroy: (process.env.APP_ALIAS ?? '') + '/api/accounts/destroy'
            , create: (process.env.APP_ALIAS ?? '') + '/api/accounts/create'
            , activate: (process.env.APP_ALIAS ?? '') + '/api/accounts/activate'
            , search: (process.env.APP_ALIAS ?? '') + '/api/accounts/search'
            , paginate: (process.env.APP_ALIAS ?? '') + '/api/accounts/paginate'
            , filter: (process.env.APP_ALIAS ?? '') + '/api/accounts/filter'
            , fulltextsearch: (process.env.APP_ALIAS ?? '') + '/api/accounts/fulltextsearch'
        },

        associations: '/associations',
        members: '/members',
        memberships: '/memberships',
        search: '/search',

        // search: {
        //     invoke: (process.env.APP_ALIAS ?? '') + '/api/search'
        // },
        

        semaphore: '/semaphore',
        reports: '/reports',
        dashboard: '/dashboard',
        singleMembershipRequests: '/single-membership-requests',
        bulkMembershipStocks:  '/bulk-membership-stocks',
        bulkMembershipRequests: '/bulk-membership-requests',
        membershipRequests: '/membership-requests',
        emailResoconti: '/email-resoconti',
        emailRegions: '/email-regions',
        emailProvinces: '/email-provinces',
        warehouse: '/warehouse',
    },

    images: {
        logo: '../storage/assets/logo.png'
    }
    
}